<template>
  <div />
</template>

<script>

/**
 * Vue: Image and text banner (image-and-text-banner)
 * -----------------------------------------------------------------------------
 * Banner section containing a single image, header, text, and CTA.
 * - Limited interactivity section, triggers 'Shop the Look' modal.
 *
 * @param {String} sectionId - Section ID.
 * @param {Boolean} enableShopTheLook - If Shop the Look is enabled.
 * @param {String} shopTheLookCollection - Handle of collection to display.
 *
 */

export default {
  name: 'ImageAndTextBanner',

  props: {
    sectionId: {
      type: String,
      default: '',
    },
    enableShopTheLook: {
      type: Boolean,
      default: false,
    },
    shopTheLookCollection: {
      type: String,
      default: '',
    },
  },

  emits: 'shop-the-look',

  mounted() {
    this.handleShopTheLook()
  },

  methods: {

    /**
     * Check for Shop the Look eligibility, set event listener if eligible.
     */
    handleShopTheLook() {
      if (!this.enableShopTheLook || this.shopTheLookCollection === null) {
        return
      }

      const button = document.querySelector(`[data-id="${this.sectionId}"] [data-shop-the-look]`)

      if (!button) {
        return
      }

      button.addEventListener('click', (event) => {
        event.preventDefault()

        window.cnvs.EventBus.emit('shop-the-look', {
          collection: this.shopTheLookCollection,
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import './image-and-text-banner';
</style>
